export const productName = 'NUCLEAR ENERGY TEACHER READY';
export const productShortName = 'Nuclear Energy Teacher Ready';
export const productImage = 'https://cdn.magicpatterns.com/uploads/iHsepQheFcQLbLHEas2BtF/MOCKUP_4.21.38_p._m..png';

export const checkoutUrl = 'https://nuclear-energy-teacher-ready.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const included = [
  'Volume 1 — Nuclear Energy Fundamentals',
  'Volume 2 — Atomic & Nuclear Science',
  'Volume 3 — Radioactivity, Radiation & Nuclear Fission',
  'Volume 4 — Nuclear Reactors & Power Plants',
  'Volume 5 — The Nuclear Fuel Cycle',
  'Volume 6 — Nuclear Safety, Radiation Protection & Risk',
  'Volume 7 — Nuclear Waste & Environmental Management',
  'Volume 8 — Nuclear Energy in Society, Economics, Climate & The Global Energy System',
  'Volume 9 — Teaching Nuclear Energy',
  'Bonus 1 — 150 Classroom Activities & Challenges',
  'Bonus 2 — Nuclear Energy Assessment Bank',
  'Bonus 3 — 100 Case Studies & Real-World Scenarios',
  'Bonus 4 — 50 Nuclear Energy Classroom Projects & Challenges',
  "Bonus 5 — Nuclear Energy Teacher's Concept & Terminology Guide",
  '7-day money-back guarantee',
  'Instant access',
];

export const systemNegatives = [
  "It's not outdated theory copied from old textbooks.",
  "It's not a collection of disconnected activities.",
  "It's not material you'll need to completely rewrite.",
];

export const closingLines = [
  'No more sleepless nights searching for ways to explain complex nuclear concepts',
  "No more rushed lessons with materials that don't work",
  "No more disconnected students who don't see nuclear energy's relevance",
  'No more weekends spent building lesson plans from scratch',
  "No more awkward silences when students ask technical questions you weren't ready for",
];
